import { Form } from '@remix-run/react'
import { Listbox, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { CheckIcon } from '@heroicons/react/20/solid'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select"
import {Button} from "~/components/ui/button";
import {Label} from "~/components/ui/label";
function getAgeOptions() {
    const today = new Date()
    const minBirthYear = today.getFullYear() - 18

    const yearOptions = []
    for (let year = minBirthYear; year >= minBirthYear - 100; year--) {
        yearOptions.push(year)
    }

    const monthOptions = []
    for (let month = 1; month <= 12; month++) {
        monthOptions.push(month)
    }

    const dayOptions = []
    for (let day = 1; day <= 31; day++) {
        dayOptions.push(day)
    }

    return {
        years: yearOptions,
        months: monthOptions,
        days: dayOptions,
    }
}

const genderOptions = ['Male', 'Female', 'Prefer not to say', 'Other']

export default function GenderDob() {
    const { years, months, days } = getAgeOptions()

    return (
        <div className={"flex flex-col gap-6 w-full max-w-sm bg-secondary p-4 rounded"} >
            <h3 className={'bold mb-6 text-2xl text-white'}>Create account</h3>
            <Form method={'post'} className='flex flex-col gap-4'>
                <input type="hidden" name="_action" value="submit-genderDob" />
              <div className="grid gap-3">
                <Label htmlFor={'year'}>Year of birth</Label>
                <Select name={'year'} defaultValue={years[0].toString()}>
                  <SelectTrigger className={'w-full'}>
                    <SelectValue placeholder="eg. 2000" />
                  </SelectTrigger>
                  <SelectContent>
                    {years.map((option) => (
                        <SelectItem key={option} value={option.toString()}>{option}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="grid gap-3">
                <Label htmlFor={'month'}>Month of birth</Label>
                <Select name={'month'} defaultValue={months[0].toString()}>
                  <SelectTrigger className={'w-full'}>
                    <SelectValue placeholder="eg. May" />
                  </SelectTrigger>
                  <SelectContent>
                    {months.map((option) => (
                        <SelectItem key={option} value={option.toString()}>{option}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="grid gap-3">
                <Label htmlFor={'day'}>Day of birth</Label>
                <Select name={'day'} defaultValue={days[0].toString()}>
                  <SelectTrigger className={'w-full'}>
                    <SelectValue placeholder="eg. 1st" />
                  </SelectTrigger>
                  <SelectContent>
                    {days.map((option) => (
                        <SelectItem key={option} value={option.toString()}>{option}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="grid gap-3">
                <Label htmlFor={'gender'}>Gender</Label>
                <Select name={'gender'} defaultValue={genderOptions[0]}>
                  <SelectTrigger className={'w-full'}>
                    <SelectValue placeholder="eg. Male" />
                  </SelectTrigger>
                  <SelectContent>
                    {genderOptions.map((option) => (
                        <SelectItem key={option} value={option.toString()}>{option}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>




                <div className={'mt-4'}>
                    <Button
                        type={'submit'}
                    >Continue</Button>
                </div>
            </Form>
        </div>
    )
}
